/**
 * Scroll-linked footer motion (port of Concept's FooterParallax /
 * ParallaxOverlay, measured — see theme-build/ANIMATION-SPEC.md
 * sections 3-4).
 *
 * - Footer parallax: the footer slides translateY(-50%) -> 0 across its
 *   ENTER into the viewport (t = entered fraction of the footer's own
 *   height, so it settles to 0 exactly when fully in view — no gap below).
 *   A `.parallax-overlay` gradient (footer bg -> transparent, opacity .8,
 *   height 100% -> 0%) is injected at the footer's top. Disabled on touch,
 *   below 750px, and for reduced motion (Concept `mobileDisabled`).
 * - Computation runs only while a target is on screen (IntersectionObserver
 *   gates a shared rAF loop — same pattern as testimonial-parallax.js).
 * - Fail-safe: transforms and the overlay exist only after successful init;
 *   supporting CSS is scoped under html.hoverfx-init.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  var targets = []; /* { el, kind: 'footer', overlay, active } */

  /* Footer parallax (non-touch, viewport >= 750px). */
  var minWidth = window.matchMedia('(min-width: 750px)');
  if (!isTouch && minWidth.matches) {
    var footer = document.querySelector('footer.footer');
    if (footer) {
      var overlay = document.createElement('div');
      overlay.className = 'parallax-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      footer.insertBefore(overlay, footer.firstChild);
      targets.push({ kind: 'footer', el: footer, overlay: overlay, active: false });
    }
  }

  if (!targets.length) return;

  document.documentElement.classList.add('hoverfx-init');

  var rafId = null;

  function clamp01(v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
  }

  function update() {
    rafId = null;
    var vh = window.innerHeight;
    var anyActive = false;
    targets.forEach(function (t) {
      if (!t.active) return;
      anyActive = true;
      var fr = t.el.getBoundingClientRect();
      /* fr.top includes the lift we already applied — add it back so the
       * progress is computed from the UNTRANSFORMED position, otherwise the
       * transform feeds back into its own input and warps the curve. */
      var trueTop = fr.top + (t.liftPx || 0);
      var pe = clamp01((vh - trueTop) / fr.height);
      var lift = (1 - pe) * 50;
      t.liftPx = (lift / 100) * fr.height;
      t.el.style.transform = lift === 0 ? '' : 'translate3d(0, -' + lift + '%, 0)';
      t.overlay.style.height = ((1 - pe) * 100) + '%';
    });
    if (anyActive) rafId = requestAnimationFrame(update);
  }

  function kick() {
    if (rafId === null) rafId = requestAnimationFrame(update);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var t = entry.target.__hoverfxTarget;
      if (!t) return;
      t.active = entry.isIntersecting;
    });
    kick();
  });

  targets.forEach(function (t) {
    t.el.__hoverfxTarget = t;
    io.observe(t.el);
  });

  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
})();
